export const version = 'kunde-v1.20.0-SNAPSHOT-d55c01a4742a67c84f8f19e968457bf9bf4434fe';